import { __rest } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import Input from '@mui/material/Input';
import InputAdornment from '@mui/material/InputAdornment';
import IconButton from '@mui/material/IconButton';
import ClearIcon from '@mui/icons-material/Clear';
export default function ClearableInput(props) {
    const { value, onClearIconClick } = props, restProps = __rest(props, ["value", "onClearIconClick"]);
    return (_jsx(Input, Object.assign({}, restProps, { value: value || '', endAdornment: value ? (_jsx(InputAdornment, { position: "end", children: _jsx(IconButton, { size: "small", onClick: onClearIconClick, edge: "end", sx: { right: 16 }, children: _jsx(ClearIcon, {}) }) })) : null })));
}
